import { useRouter } from 'next/router';
import { useNarrow } from './use-narrow';
import { CHATS_LIST_DEFAULT_WIDTH } from './use-chats-list-width';

// A full rail, a list and a useful 440px transcript fit at 1080px. Below that Chats uses
// list → conversation navigation; the ordinary app breakpoint stays unchanged. The list's own
// default is the design's 814 (`use-chats-list-width.ts`), which `clampChatsListWidth` narrows on
// a window this size — the breakpoint is about whether a SPLIT is worth having at all, not about
// any one list width, so it does not move with that default.
export const CHATS_SPLIT_MIN_WIDTH = 1080;
/** @deprecated The list width is now user-resizable (`use-chats-list-width.ts`); this is
 * only the pre-drag default, kept for the odd consumer that still wants a constant. */
export const CHATS_LIST_WIDTH = CHATS_LIST_DEFAULT_WIDTH;
// The list's LIVE width is mirrored onto :root as --chats-list-w by AppFrame (same pattern
// as --sidebar-w / --chat-w), so this always reflects a drag without every consumer having
// to re-render off the store directly.
export const CHATS_DOCK_WIDTH = 'calc(100vw - var(--sidebar-w, 280px) - var(--chats-list-w, 814px))';

export function useChatsLayout() {
  const { pathname } = useRouter();
  const stacked = useNarrow(CHATS_SPLIT_MIN_WIDTH);
  const onChats = pathname === '/chats';
  return { onChats, split: onChats && !stacked, stacked: onChats && stacked };
}
